import { useTheme } from '@mui/material';
import { FieldRenderBlockProp } from '../..';
import ListAvatarBlock from '../../_utils/list-avatar-block';

export default function GoogleReviewBlockRenderer(props: FieldRenderBlockProp) {
  const theme = useTheme();

  if (!props.data?.googleReview) return <></>;

  return (
    <ListAvatarBlock
      title={props.data.googleReview?.title}
      value={props.data.googleReview?.value}
      e={props}
    />
  );
}
